// Material
import { Divider } from '@mui/material'
// Common
import { EmptyStateList } from '$common/empty-state-list'
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { withSearchableListPage } from '$common/searchable-list-page'
import { closeShareContactList } from '$logic/router'
import {
  useSearchedSignedUpContactIds,
  useSignedUpContactIds,
} from '$logic/contacts/react-hook'
import { SignedUpContact } from '$logic/contacts/types'
import { showShareContactDialog } from '$comp/modals/share-contact-dialog'
// Localization
import { t } from '$i18n'

const onChooseContact = async (userId: string) => {
  showShareContactDialog({ userId })
}

const ListItem = ({ id }: { id: string }) => (
  <>
    <UserListItemWithStatus
      userId={id}
      hasDivider={false}
      onClick={() => onChooseContact(id)}
    />
    <Divider variant="inset" />
  </>
)

const Page = withSearchableListPage<SignedUpContact, null, string>({
  appBarTitle: t('shareContact.choose'),
  ListItem,
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: useSignedUpContactIds,
  searchHook: useSearchedSignedUpContactIds,
  onBack: closeShareContactList,
})

export function ShareContactList() {
  return <Page fetchHookParams={null} getSearchHookParams={query => query} />
}
